import React from 'react';

const MovieList = (props) => {
    const FavouriteComponent = props.favouriteComponent;

    return(
        <>
            {props.movies.map((movie, index)=>
                <div className="image-container d-flex justify-content-start m-3">
                    <img onClick={(e)=>props.getMovieInfo(e.currentTarget.alt)} src={movie.Poster} alt={movie.Title}/>
                    <div onClick={()=>props.handleFavouritesClick(movie)} className='overlay d-flex align-items-center justify-content-center'>
                        <FavouriteComponent/>
                    </div>
                </div>
            )}

        </>
    )
}

export default MovieList;